import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { z } from 'zod';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';

// The parameter is optional because it is removed from the URL after mount.
const pageParamsSchema = z.object({
  dealId: z.string().optional().catch(undefined),
});

/**
 * Captures `dealId` from the URL on mount, then removes it from the URL.
 * The captured deal ID is stored and reused on subsequent renders.
 */
export const useDealIdFromUrl = (): string | undefined => {
  const pageParams = usePageParamsFromSchema(pageParamsSchema);
  const navigate = useNavigate();
  const location = useLocation();
  const [dealId] = useState(() => pageParams.value.dealId);

  useEffect(() => {
    if (!pageParams.value.dealId) return;

    // Replace the current history entry to prevent browser navigation from
    // restoring the URL with `dealId`. Preserve the existing navigation state.
    navigate(
      { search: pageParams.toSearchParams({ dealId: undefined }) },
      { replace: true, state: location.state }
    );

    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return dealId;
};
